import { Card } from "antd";
import Text from 'antd/es/typography/Text';

interface IProps {
    theme: 'light' | 'dark';
    label: string;
    value: string | number;
}

export const CardItem = ({ theme, label, value }: IProps) => {
    const isDark = theme === 'dark';

    return (
        <Card
            bodyStyle={{ padding: '12px 14px' }}
            className='info-item'
            style={{
                borderRadius: 8,
                padding: 0,
                background: isDark ? '#1f1f1f' : '#f8fafc',
                border: `1px solid ${isDark ? '#2d2d2d' : '#e2e8f0'}`,
            }}
        >
            <div style={{ display: "flex", flexDirection: "column" }}>
                <Text
                    className='section-label'
                    type='secondary'
                    style={{
                        fontSize: 12,
                        marginBottom: 4,
                        color: isDark ? '#94a3b8' : '#64748b',
                        fontWeight: 500,
                    }}
                >
                    {label}:
                </Text>
                <Text
                    className='section-text'
                    style={{
                        fontWeight: 700,
                        fontSize: 14,
                        color: isDark ? '#f1f5f9' : '#0f172a',
                    }}
                >
                    {value}
                </Text>
            </div>
        </Card>
    );
};

